<template>
  <div>
    <div class="search-view">
      <div class="search-header" ref="searchHeader">
        <search-input v-if="searchCategory === 'all'" :is-nav-tab="isNavTab"/>
        <search-header-title v-else :search-category="searchCategory" :m-type="mType"/>
        <div class="tag-search-list">
          <div class="flex-wrapper">
            <div v-for="(tag, index) in contentTagSearchList"
                 :key="tag.text+index"
                 :class="tag.selected === 'y' ? 'tag-item selected' : 'tag-item'"
                 @click.prevent="()=>setFilterTagResult(tag)">
              #{{tag.text}}
            </div>
          </div>
        </div>
      </div>
      <!--
      *클래스 들어가는 예시: search-wrapper search-list with-tag-list with-tag-refresh
      -->
        <search-tag-result-band v-if="isTagSearchLoaded && searchCategory === 'all'"
                                     :tag-search-list="selectedTagSearchList"
                                     :search-category="searchCategory"
                                     :search-type="listType"
                                     :mType="mType"
                                     :multisection-list="multisectionList" />
        <search-result-list v-if="isTagSearchLoaded && searchCategory !== 'all'"
                            :type="searchCategory"
                            :tag-search-list="selectedTagSearchList"
                            :m-type="mType"
                            :isNavTab="isNavTab"
        />
    </div>
  </div>
</template>

<script>
import { SearchService } from '@/common/api/api.service'
import { get } from 'lodash'
import { enableBodyScroll } from '@/common/util/ui.utils'
import SearchTagResultBand from '@/components/search/SearchTagResultBand'
import MultiSectionModel from '@/common/model/MultiSectionModel'
import { PATH_NAME_SEARCH_TAG_GROUP } from '@/common/router.const'
import SearchInput from '@/components/search/SearchInput'
import SearchHeaderTitle from '@/components/search/SearchHeaderTitle'
import SearchResultList from '@/components/search/SearchResultList'
export default {
  name: 'SearchTagGroup',
  components: {
    SearchInput,
    SearchTagResultBand,
    SearchHeaderTitle,
    SearchResultList
  },
  data () {
    return {
      tagCode: '',
      tagText: '',
      contentId: '',
      listType: '',
      contentTagSearchList: [],
      selectedTagSearchList: [],
      multisectionList: [],
      isTagSearchLoaded: false,
      searchCategory: 'all',
      mType: 'all',
      isNavTab: get(this.$route, 'query.bt', 'y') === 'y'
    }
  },
  methods: {
    setSearchTagData () {
      this.isTagSearchLoaded = false
      this.selectedTagSearchList = this.contentTagSearchList.filter((tag) => tag.value === this.tagCode)
      SearchService.tagAllSearch({
        limit: 20,
        offset: 0,
        orderby: 'score',
        type: this.listType,
        searchtags: this.selectedTagSearchList
      }).then(({ data }) => {
        this.multisectionList = Number(get(data, 'totalcount', 0)) > 0
          ? get(data, 'multisectionlist', []).map((multiSection) => {
            return new MultiSectionModel(multiSection)
          })
          : this.multisectionList = []
        this.isTagSearchLoaded = true
      })
    },
    getQuery (key, defaultValue) {
      return get(this.$route, ['query', key], defaultValue)
    },
    init () {
      this.tagCode = this.getQuery('tagCode', '')
      this.tagText = this.getQuery('tagText', '')
      this.contentId = this.getQuery('contentId', '')
      this.listType = this.getQuery('listType', 'vod')
      this.searchCategory = this.getQuery('searchCategory', 'all')
      this.mType = this.getQuery('mType', 'all')
    },
    async setTagsList () {
      this.contentTagSearchList = get(await
      SearchService.getTagsList({ type: this.listType, contentid: this.contentId, tag: this.tagCode }),
      'data.taggrouplist', [])
    },
    setFilterTagResult (tag) {
      this.$router.replace({
        name: PATH_NAME_SEARCH_TAG_GROUP,
        query: {
          tagCode: get(tag, 'value', ''),
          tagText: get(tag, 'text', 'text'),
          contentId: this.contentId,
          listType: this.listType,
        }
      })
    },
    load () {
      this.init()
      this.setTagsList().then(() => {
        this.setSearchTagData()
      })
    }
  },
  mounted () {
    enableBodyScroll()
  },
  created () {
    this.load()
  },
  watch: {
    $route () {
      this.load()
    }
  }
}
</script>
<style lang="css" src="@/assets/new-css/search.css"></style>
<style scoped>
.tag-item{
  padding: 6px 20px;
}
</style>
